import axios from 'axios'
import { Message } from 'element-ui'
import { setToken, removeToken, getToken } from '@/utils/getToken.js'
import router from '@/router';
import store from '@/store'



// 创建axios实例
const request = axios.create({
    // 这里可以放一下公用属性等。
    // baseURL: 'http://localhost:8888/full-geek', // 用于配置请求接口公用部分，请求时会自动拼接在你定义的url前面。
    baseURL: 'http://m15652314175.oicp.net:45449/full-geek',
    timeout: 10 * 1000, // 请求超时时间
})

// 请求拦截器，用于在每个请求中添加 token 到请求头
request.interceptors.request.use(config => {
    const token = localStorage.getItem('token'); // 从本地存储中获取 token
    if (token) {
        config.headers.Authorization = token; // 设置请求头中的 Authorization 字段为 token
        config.headers['Content-Type'] = 'application/json'; // 设置请求头中的 Content-Type 字段为 application/json
    }
    // config.headers['Organizationid'] = 2; // 设置请求头中的 organizationId 字段为 organizationId

    return config;
}, error => {
    return Promise.reject(error);
});


request.interceptors.response.use((response) => {
    //返回码以自己的为定，如果没有安装elementui就换成自己的提示

    let code = response.status || undefined
    let msg = response.data.message || undefined

    if (code == 200 && response.data.code == 1000 && response.data.message == '登出成功') {
        Message({ message: '已登出', type: 'success' })
        removeToken('Authorization');
        router.push('/login').catch(() => {});
        return
    }

    if (code != 200) {
        Message({ message: msg || 'error', type: 'error', showClose: true, duration: 2000 })
        response.data.status = 'error'
    } else if (response.data && response && typeof response.data === 'object') {
        response.data.status = 'ok'
    }
    return response.data; //此处可以只返回后端传出的数据（第一层data是axios封装的）
}, (error) => {
    if (error.code == "ERR_NETWORK") {
        Message({ message: error.message || 'error', type: 'error', showClose: true, duration: 2000 })
        return error
    }
    // if (error.code == "ERR_BAD_REQUEST") {
    //     // Message({ message: 'ERR_BAD_REQUEST', type: 'warning', showClose: true, duration: 2000 })
    //     return error
    // }
    let response
    if (error.response) {
        response = error.response.data;
    } else {
        response = {}
    }

    // let response = (error.response ? .data) || {};


    if (response.code == 1005) {
        // removeToken('Authorization');
        Message({ message: response.message || 'error', type: 'warning', showClose: true, duration: 2000 })
            // router.push('/login').catch(() => {});
        return response
    }

    if (response.code == 1004) {
        console.log(response)
        removeToken('Authorization');
        if (response.message == '未登录') {
            Message({ message: '游客模式', showClose: true, duration: 2000 })
            return response
        }
        Message({ message: response.message || 'error', type: 'warning', showClose: true, duration: 2000 })
        return response
    }

    if (response.code == -1) {
        Message({ message: response.message || 'error', type: 'warning', showClose: true, duration: 2000 })
        return response
    }

    // if (error.response) {
    //     let msg = error.response.data ? .message
    //     let code = error.response.status
    // }


    if (error.response && response.code === 400) {
        // 在这里处理状态码为 400 的错误
        Message.error(msg || '出错了');
    }
    return error
})

export default request; //记得暴露出去